import * as React from "react";
import { Columns, Column } from "@origin-digital/ods-core";
import { logger } from "@origin-digital/reporting-client";
import styled from "styled-components";
import { QuickLink, IQuickLink } from "./QuickLink";

const qlToColumn = (ql: IQuickLink) => (
  <Column alignX="center">
    <QuickLink {...ql} />
  </Column>
);

export interface IQuickLinks {
  quickLinks: IQuickLink[];
}

const QuickLinksContainer = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.grey100};
  border-left: 1px solid ${(props) => props.theme.colors.grey100};

  & .QuickLinkContainer {
    border-right: 1px solid ${(props) => props.theme.colors.grey100};
    border-bottom: 1px solid ${(props) => props.theme.colors.grey100};
  }
`;

export const QuickLinks = ({ quickLinks }: IQuickLinks) => {
  if (quickLinks.length < 8) {
    logger.error("QuickLinks layout expects 8 elements, will not render");
    return null;
  }
  return (
    <QuickLinksContainer data-id="quicklinks">
      <Columns space="none" collapseBelow="sm">
        <Column alignX="center">
          <Columns space="none">
            {qlToColumn(quickLinks[0])}
            {qlToColumn(quickLinks[1])}
          </Columns>
        </Column>
        <Column alignX="center">
          <Columns space="none">
            {qlToColumn(quickLinks[2])}
            {qlToColumn(quickLinks[3])}
          </Columns>
        </Column>
      </Columns>
      <Columns space="none" collapseBelow="sm">
        <Column alignX="center">
          <Columns space="none">
            {qlToColumn(quickLinks[4])}
            {qlToColumn(quickLinks[5])}
          </Columns>
        </Column>
        <Column alignX="center">
          <Columns space="none">
            {qlToColumn(quickLinks[6])}
            {qlToColumn(quickLinks[7])}
          </Columns>
        </Column>
      </Columns>
    </QuickLinksContainer>
  );
};
